var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHackathonBackground2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 208,
    viewBox: "0 0 207 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.6 207.5L248.4 207.5L248.4 124.7L331.2 124.7L331.2 41.9L414 41.9L414 -40.9L331.2 -40.9L331.2 -123.7L248.4 -123.7L248.4 -206.5L165.6 -206.5L165.6 -123.7L82.8 -123.7L82.8 -40.9L7.77264e-07 -40.9L5.18176e-07 41.9L82.8 41.9L82.8 124.7L165.6 124.7L165.6 207.5ZM165.6 41.9L248.4 41.9L248.4 -40.9L165.6 -40.9L165.6 41.9Z",
    fill: "#00BDE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackathonBackground2);
export default __webpack_public_path__ + "static/media/hackathon-background2.7133ddc71de9670e8a7893751a03e06a.svg";
export { ForwardRef as ReactComponent };